import type { LucideIcon } from 'lucide-react'
import {
  ClipboardList,
  Globe2,
  LayoutDashboard,
  MapPin,
  MessageSquareText,
  Route,
  Ticket,
  Users,
} from 'lucide-react'

export interface NavItem {
  key: string
  labelKey: string
  route: string
  icon: LucideIcon
  superAdminOnly?: boolean
  tenantAdminOnly?: boolean
}

export interface NavSection {
  labelKey: string
  items: NavItem[]
}

export const NAV_SECTIONS: NavSection[] = [
  {
    labelKey: 'sidebar.general',
    items: [
      {
        key: 'dashboard',
        labelKey: 'sidebar.dashboard',
        route: '/dashboard',
        icon: LayoutDashboard,
      },
      { key: 'tenant', labelKey: 'sidebar.tenants', route: '/tenant', icon: Users },
      // { key: 'users', labelKey: 'sidebar.users', route: '/users', icon: UserCog, superAdminOnly: true },
      {
        key: 'destinations',
        labelKey: 'sidebar.destinations',
        route: '/destinations',
        icon: MapPin,
      },
      {
        key: 'locations',
        labelKey: 'sidebar.locations',
        route: '/locations',
        icon: Globe2,
        superAdminOnly: true,
      },
      { key: 'pois', labelKey: 'sidebar.pois', route: '/pois', icon: MapPin },
      { key: 'tours', labelKey: 'sidebar.tours', route: '/tours', icon: Route },
      { key: 'surveys', labelKey: 'sidebar.surveys', route: '/surveys', icon: ClipboardList },
      {
        key: 'surveyResponses',
        labelKey: 'sidebar.surveyResponses',
        route: '/surveys/responses',
        icon: MessageSquareText,
      },
      // { key: 'vouchers', labelKey: 'sidebar.vouchers', route: '/vouchers', icon: Ticket },
      {
        key: 'tickets',
        labelKey: 'sidebar.tickets',
        route: '/tickets',
        icon: Ticket,
        superAdminOnly: true,
      },
      {
        key: 'ticketFeatures',
        labelKey: 'sidebar.ticketFeatures',
        route: '/ticket-features',
        icon: Ticket,
        superAdminOnly: true,
      },
      {
        key: 'ticketConfigs',
        labelKey: 'sidebar.ticketConfigs',
        route: '/ticket-configs',
        icon: Ticket,
      },
    ],
  },
]

export const SIDEBAR_WIDTH = 240
export const SIDEBAR_COLLAPSED_WIDTH = 72
